import { Navigate, useParams } from '@exam-management/router';

export default function QuestionCreationTaskDetailsRouteController() {
  // TODO: handle permission
  const { taskId } = useParams('/my-task/question-creation/:taskId');

  return <Navigate to='/my-task/question-creation/:taskId/details' params={{ taskId }} />;
}
